var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('b-field',[_c('b-input',{attrs:{"placeholder":_vm.$t('evenement.chercher_evenement'),"type":"search","icon":"magnify"},on:{"input":function($event){return _vm.search()}},model:{value:(_vm.search_query),callback:function ($$v) {_vm.search_query=$$v},expression:"search_query"}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30a849c1","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/event/components/SearchBar.vue
// module id = null
// module chunks = 